import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { MagicLinkVerifyResponse, PortalUser, Practice } from '../../shared/models';
import { environment } from '../../../environments/environment';

const PORTAL_TOKEN_KEY = 'portal_token';

@Injectable({ providedIn: 'root' })
export class PortalAuthService {
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);

  private readonly _user = signal<PortalUser | null>(null);
  readonly user = this._user.asReadonly();
  readonly isAuthenticated = computed(() => this._user() !== null);

  getToken(): string | null {
    return localStorage.getItem(PORTAL_TOKEN_KEY);
  }

  verifyMagicLink(token: string): Observable<MagicLinkVerifyResponse> {
    return this.http.get<MagicLinkVerifyResponse>(`${environment.apiUrl}/auth/magic-link/verify`, {
      params: { token },
    }).pipe(
      tap((res) => {
        localStorage.setItem(PORTAL_TOKEN_KEY, res.access_token);
      })
    );
  }

  requestMagicLink(email: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${environment.apiUrl}/auth/magic-link/request`, { email });
  }

  loadCurrentUser(): Observable<PortalUser> {
    return this.http.get<PortalUser>(`${environment.apiUrl}/portal/me`).pipe(
      tap((user) => this._user.set(user))
    );
  }

  listPractices(): Observable<Practice[]> {
    return this.http.get<Practice[]>(`${environment.apiUrl}/portal/practices`);
  }

  logout(): void {
    localStorage.removeItem(PORTAL_TOKEN_KEY);
    this._user.set(null);
    this.router.navigate(['/auth/request-link']);
  }
}
